/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Cart } from './Cart';
import {
    CartFromJSON,
    CartFromJSONTyped,
    CartToJSON,
} from './Cart';

/**
 * Representation of a Cart list
 * @export
 * @interface CartList
 */
export interface CartList {
    /**
     * List of carts
     * @type {Array<Cart>}
     * @memberof CartList
     */
    carts?: Array<Cart>;
}

/**
 * Check if a given object implements the CartList interface.
 */
export function instanceOfCartList(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CartListFromJSON(json: any): CartList {
    return CartListFromJSONTyped(json, false);
}

export function CartListFromJSONTyped(json: any, ignoreDiscriminator: boolean): CartList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'carts': !exists(json, 'carts') ? undefined : ((json['carts'] as Array<any>).map(CartFromJSON)),
    };
}

export function CartListToJSON(value?: CartList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'carts': value.carts === undefined ? undefined : ((value.carts as Array<any>).map(CartToJSON)),
    };
}

